import { STATE_PER_METRO, AUSTRALIA, STATE_FULL_NAMES, CountryState, Metro } from '../constants';

export type LocationChoice = StateChoice | MetroChoice | SuburbChoice;

export interface StateChoice {
  state: CountryState;
  metro?: undefined;
  suburb?: undefined;
}

export interface MetroChoice {
  metro: Metro;
  state?: undefined;
  suburb?: undefined;
}

export interface SuburbChoice {
  suburb: {
    name?: string;
    postcode?: string;
    state?: CountryState;
  };
  state?: undefined;
  metro?: undefined;
}

export const renderLocationInOrNear = (location?: LocationChoice) => {
  if (!location || location.metro || location.state) return 'in';
  return 'near';
};

export const renderLocationChoice = (location?: LocationChoice) => {
  const metro = location?.metro;
  const suburb = location?.suburb;
  const state = location?.state;

  if (metro) {
    return `${metro} City, ${STATE_PER_METRO[metro] ?? AUSTRALIA}`;
  }

  if (suburb) {
    return `${suburb.name}, ${suburb.state} ${suburb.postcode}`;
  }

  if (state) {
    return STATE_FULL_NAMES[state] ?? state;
  }

  return AUSTRALIA;
};
